export const COLORS = {
  white: "#fbf2f2ff",
  red: "#ec6962ff",
  blue: "#3aa3cc",
  green: "#7bc33cff",
  yellow: "#ffff6e",
  orange: "#f38f15"
};
